import * as React from "react";
import {useState} from "react";
import SettingCard, {ISettingCard} from "../../../../../../../../ui/settingcard/settingcard";
import DotIndicator from "../../../../../../../../ui/dotindicator/dotindicator";
import HorizontalDivider from "../../../../../../../../ui/horizontaldivider/horizontaldivider";
import "./tab1.scss";

const Tab1 = () => {
    const [activateAd, setActivateAd] = useState("setting0");
    const [activateSocial, setActivateSocial] = useState("setting0");
    const [activateTypeContent, setActivateTypeContent] = useState("setting0");
    const adSettingItems: ISettingCard[] = [
        {
            title: "بازدیدی",
            body: "متن تستی برای توضیحات",
            id: 0,
            activate: activateAd,
            setActivate: setActivateAd
        },
        {
            title: "اینفلوینسری و تعرفه ای",
            body: "متن تستی برای توضیحات",
            id: 1,
            activate: activateAd,
            setActivate: setActivateAd
        }
    ]
    const socialSettingItems: ISettingCard[] = [
        {
            title: "اینستاگرام",
            body: "متن تستی برای توضیحات",
            id: 0,
            activate: activateSocial,
            setActivate: setActivateSocial
        },
        {
            title: "تلگرام",
            body: "متن تستی برای توضیحات",
            id: 1,
            activate: activateSocial,
            setActivate: setActivateSocial
        }
    ]
    const contentTypeSettingItems: ISettingCard[] = [
        {
            title: "پست",
            body: "متن تستی برای توضیحات",
            id: 0,
            activate: activateTypeContent,
            setActivate: setActivateTypeContent
        },
        {
            title: "پست فورواردی",
            body: "متن تستی برای توضیحات",
            id: 1,
            activate: activateTypeContent,
            setActivate: setActivateTypeContent
        }
    ]
    return (
        <div className="Tab1">
            <div className="row pt-3">
                <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                    <DotIndicator size={"16px"}/>
                    <span>نوع تبلیغ</span>
                </div>
                {
                    adSettingItems.map((adSettingItem, index) => {
                        return (
                            <div className="col-lg-5 col-md-6 col-12 mb-2">
                                <SettingCard activate={adSettingItem.activate} title={adSettingItem.title}
                                             body={adSettingItem.body}
                                             setActivate={adSettingItem.setActivate} id={index}/>
                            </div>
                        );
                    })
                }
            </div>
            <HorizontalDivider/>
            <div className="row pt-3">
                <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                    <DotIndicator size={"16px"}/>
                    <span>شبکه های اجتماعی</span>
                </div>
                {
                    socialSettingItems.map((socialSettingItem, index) => {
                        return (
                            <div className="col-lg-5 col-md-6 col-12 mb-2">
                                <SettingCard activate={socialSettingItem.activate} title={socialSettingItem.title}
                                             body={socialSettingItem.body}
                                             setActivate={socialSettingItem.setActivate} id={index}/>
                            </div>
                        );
                    })
                }
            </div>
            <HorizontalDivider/>
            <div className="row pt-3">
                <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                    <DotIndicator size={"16px"}/>
                    <span>نوع محتوا</span>
                </div>
                {
                    contentTypeSettingItems.map((typeSettingItem, index) => {
                        return (
                            <div className="col-lg-5 col-md-6 col-12 mb-2">
                                <SettingCard activate={typeSettingItem.activate} title={typeSettingItem.title}
                                             body={typeSettingItem.body}
                                             setActivate={typeSettingItem.setActivate} id={index}/>
                            </div>
                        );
                    })
                }
            </div>
            <HorizontalDivider/>
        </div>
    );
}

export default Tab1;